/**
 * Renders a blog content block (paragraph, heading, list) into JSX.
 */
export function ContentBlock({ paragraph, index }) {
  if (paragraph.startsWith('## ')) {
    return (
      <h2 className="text-2xl font-bold text-slate-900 font-['Outfit'] mt-10 mb-4">
        {paragraph.replace('## ', '')}
      </h2>
    );
  }

  if (paragraph.startsWith('### ')) {
    return (
      <h3 className="text-xl font-semibold text-slate-900 font-['Outfit'] mt-8 mb-3">
        {paragraph.replace('### ', '')}
      </h3>
    );
  }

  if (paragraph.startsWith('- ')) {
    const items = paragraph.split('\n').filter(item => item.startsWith('- '));
    return (
      <ul className="list-none space-y-2 my-4">
        {items.map((item) => (
          <li key={item} className="flex items-start gap-2 text-slate-600 font-['Plus_Jakarta_Sans']">
            <div className="w-1.5 h-1.5 bg-blue-600 rounded-full mt-2.5 flex-shrink-0" />
            {item.replace('- ', '')}
          </li>
        ))}
      </ul>
    );
  }

  if (/^\d+\./.test(paragraph)) {
    const items = paragraph.split('\n').filter(item => /^\d+\./.test(item));
    return (
      <ol className="list-none space-y-3 my-4">
        {items.map((item, itemIndex) => (
          <li key={item} className="flex items-start gap-3 text-slate-600 font-['Plus_Jakarta_Sans']">
            <span className="font-bold text-blue-600">{itemIndex + 1}.</span>
            <span>{item.replace(/^\d+\.\s*/, '')}</span>
          </li>
        ))}
      </ol>
    );
  }

  return (
    <p className="text-slate-600 leading-relaxed mb-6 font-['Plus_Jakarta_Sans']">
      {paragraph}
    </p>
  );
}
